import { useSetArrivedOnMarketLink } from '@shared/sessionStorageForSiteVisitors';
import DeprecatedLandlordWithoutBrandedAssets from './DeprecatedLandlordWithoutBrandedAssets';

export const DeprecatedVtsMarketLandlordShare = props => {
  useSetArrivedOnMarketLink();

  return <DeprecatedLandlordWithoutBrandedAssets {...props} />;
};

export default DeprecatedVtsMarketLandlordShare;
